import { Marker, MarkerClusterer } from "@googlemaps/markerclusterer";
import { useContext, useEffect, useState } from "react";
import SubStore from "../../../../images/SubsidiaryLocation.svg";
import {
  AdvancedMarker,
  InfoWindow,
  Map,
  Pin,
  useMap,
  AdvancedMarkerAnchorPoint,
} from "@vis.gl/react-google-maps";
import {
  GetCompOrJuncOrAssetOrSubAndSiteNodeResult,
  GetDataForMapsResult,
} from "../masters/items/queries/types";
import { MapsContext } from "./context/context";
import Information from "../../../../images/Information.svg";
import ViewImage from "../../../../images/EyeWhite.svg";
import { CustomModal } from "../../../../utils/UtilFunctions";
import { ViewItemModalStyles } from "../../../../styles/CustomModalStyles";
import CompanyDetails from "./items/CompanyDetails";
import { MapPageFor } from "../../../../utils/Enum.types";
import TicketInfoWindow from "./infowindow/TicketInfoWindow";
import { mapsPayloadType } from "./context/reducer";
import { MapProps } from "./MyMaps";
import useLabels from "../../../../customHooks/useLabels";
import { TicketStatus } from "../../../../utils/constants";
import { CustomRenderer } from "../DashBoardMapsView/MapsView";
import { AppContext } from "../../../../context/context";
import { payloadTypes } from "../../../../context/reducer";
import CoordinatesSearch from "../DashBoardMapsView/CoordinatesSearch";
import MapHandler from "../DashBoardMapsView/MapHandler";
// import { CustomRenderer } from "../shivuMapsView/MapsView";

export interface longLatPos {
  lat: number;
  lng: number;
}

type PointsProp = {
  points: GetDataForMapsResult[];
};
type Tree = {
  key: string;
  name: string;
  lat: number;
  lng: number;
};

const MapsView = ({
  items,
  pageFor,
  clusterer,
  selectedPlace,
  sub_sites,
  setAssetdetails,
  setRaisedTicketDetails,
  assetType,
  setJunctionLevelRaisedTicketModal,
  searchCoordinates,
}: MapProps) => {
  const [viewDetails, setViewDetails] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(false);

  const { dispatch } = useContext(MapsContext);
  const { dispatch: globalDispatch, state: globalState } =
    useContext(AppContext);
  const defaultCenter = {
    lat: 12.981010391578677,
    lng: 77.60151962452281,
  };

  const [openWindow, setOpenWindow] = useState<longLatPos>({
    lat: 0,
    lng: 0,
  });

  const Markers = ({ points }: PointsProp) => {
    const map = useMap();
    const [markers, setMarkers] = useState<{ [key: string]: Marker }>({});

    useEffect(() => {
      clusterer.current = null;
    }, []);
    useEffect(() => {
      if (!map) return;
      if (!clusterer.current)
        clusterer.current = new MarkerClusterer({
          map,
          renderer: new CustomRenderer(),
        });
    }, [map, points]);

    useEffect(() => {
      clusterer.current?.clearMarkers();

      clusterer.current?.addMarkers(Object.values(markers));
    }, [markers, points]);

    // const handleRefs = (marker: Marker | null, key: number) => {
    //   if (marker && markers[key]) return;
    //   if (!marker && !markers[key]) return;

    //   setMarkers((prev) => {
    //     if (marker) {
    //       return { ...prev, [key]: marker };
    //     } else {
    //       const newMarkers = { ...prev };
    //       delete newMarkers[key];
    //       return newMarkers;
    //     }
    //   });
    // };
    const { subsidiaryLabel, companyLabel } = useLabels();
    return (
      <>
        {points.map(
          (
            { companyID, icon, id, latitude, longitude, name, ticketStatus },
            key,
          ) => {
            const itemPoint: Tree = {
              key: JSON.stringify({
                name,
                latitude,
                longitude,
              }),
              lat: Number(latitude),
              lng: Number(longitude),
              name,
            };
            let img = "";

            img = require(
              `${process.env.React_App_Display_Map_Icons}/${
                icon && icon !== "item" ? icon : "camera"
              }.svg`,
            );

            return (
              <>
                <AdvancedMarker
                  position={itemPoint}
                  // ref={(marker) => handleRefs(marker, key)}
                  onClick={() => {
                    dispatch({
                      type: mapsPayloadType.ASSET,
                      payload: {
                        asset: {
                          label: name,
                          value: id,
                        },
                      },
                    });

                    clusterer.current?.clearMarkers();

                    if (pageFor === MapPageFor.VIEW) {
                      setOpenWindow({
                        lat: Number(latitude),
                        lng: Number(longitude),
                      });
                    } else {
                      if (ticketStatus === TicketStatus.CLOSED) {
                        setAssetdetails({
                          flag: true,
                          itemId: id,
                          tableLevel: assetType,
                        });
                      } else {
                        // setRaisedTicketDetails({
                        //   flag: true,
                        //   itemId: id,
                        // });
                        setJunctionLevelRaisedTicketModal({
                          flag: true,
                          itemId: id,
                          tableLevel: assetType,
                        });
                      }
                    }
                  }}
                >
                  <div
                    className={`marker feature status__${ticketStatus.toLocaleLowerCase()}`}
                  >
                    <img
                      src={img}
                      className={`marker-img .status__${ticketStatus.toLocaleLowerCase()}`}
                      alt="Image not found"
                    />
                  </div>
                </AdvancedMarker>
              </>
            );
          },
        )}
      </>
    );
  };

  return (
    <>
      <div className="map-view">
        <Map
          defaultZoom={9}
          defaultCenter={defaultCenter}
          mapId={process.env.React_App_Map_ID}
          gestureHandling={"greedy"}
        >
          <Markers points={items} />
          <MapHandler
            place={selectedPlace}
            searchCoordinates={searchCoordinates}
          />
          <CoordinatesSearch searchCoordinates={searchCoordinates} />
        </Map>
      </div>

      <CustomModal
        style={ViewItemModalStyles}
        isOpen={companyDetails}
        onRequestClose={() => setCompanyDetails(!companyDetails)}
        contentComponent={<CompanyDetails setModalFlag={setCompanyDetails} />}
      />
    </>
  );
};

export default MapsView;
